import Session from '../core/session'
import BinderContainer from './containers/BinderContainer'
import VueRouter from "vue-router";

export default {
    items: [
        {
            name: 'Tableau de bord',
            url: '/tableau-de-bord',
            icon: 'fa fa-line-chart',
            badge: {
                variant: 'primary',
            },
            meta: {
                caps: [
                    'dashboard_payments',
                    'dashboard_events',
                    'dashboard_subscriptions'
                ]
            }
        },
        {
            name: 'Visiteurs',
            url: '/visiteurs',
            icon: 'cui-user-follow',
            meta: {
                caps: [
                    'visitor_management_get'
                ]
            }
        },
        {
            title: true,
            name: 'Événement',
            class: '',
            meta: {
                caps: [
                    'anonymous',
                    'event_booking',
                    'event_booking_management_get',
                    'event_calendar_management_get',
                    'event_management_get',
                    'season_management_get'
                ]
            }
        },
        {
            name: 'Calendrier',
            url: '/evenement/reserver',
            icon: 'cui-calendar',
            meta: {
                caps: [
                    'anonymous',
                    'event_booking'
                ]
            }
        },
        {
            name: 'Mes réservations',
            url: '/evenement/mes-reservations',
            icon: 'fa fa-check',
            meta: {
                caps: [
                    'event_booking'
                ]
            }
        },
        {
            name: 'Réservations',
            url: '/evenement/reservations',
            icon: 'cui-user-follow',
            meta: {
                caps: [
                    'event_booking_management_get'
                ]
            }
        },
        {
            name: 'Calendrier',
            url: '/evenement/calendrier',
            icon: 'cui-calendar',
            meta: {
                caps: [
                    'event_calendar_management_get'
                ]
            }
        },
        {
            name: 'Événements',
            url: '/evenement/evenements',
            icon: 'cui-note',
            meta: {
                caps: [
                    'event_management_get'
                ]
            }
        },
        {
            name: 'Saisons',
            url: '/evenement/saisons',
            icon: 'fa fa-calendar-o',
            meta: {
                caps: [
                    'season_management_get'
                ],
                settings: [
                    'event.seasonIsEnabled'
                ]
            }
        },
        {
            title: true,
            name: 'Commerce',
            class: '',
            meta: {
                caps: [
                    'anonymous',
                    'shopping',
                    'order_get',
                    'subscription_get',
                    'subscription_get',
                    'order_management_get',
                    'subscription_management_get'
                ]
            }
        },
        {
            name: 'Boutique',
            url: '/commerce/boutique',
            icon: 'fa fa-shopping-cart',
            meta: {
                caps: [
                    'anonymous',
                    'shopping'
                ]
            }
        },
        {
            name: 'Mes commandes',
            url: '/commerce/mes-commandes',
            icon: 'cui-basket-loaded',
            meta: {
                caps: [
                    'order_get'
                ],
                displayConditions: 'hasOrders'
            }
        },
        {
            name: 'Mes abon. limités',
            url: '/commerce/mes-abonnements-limites',
            icon: 'fa fa-sort-numeric-desc',
            meta: {
                caps: [
                    'subscription_get'
                ],
                displayConditions: 'hasLimitedSubscriptions'
            }
        },
        {
            name: 'Mes abon. récurrents',
            url: '/commerce/mes-abonnements-recurrents',
            icon: 'fa fa-refresh',
            meta: {
                caps: [
                    'subscription_get'
                ],
                displayConditions: 'hasRecurringSubscriptions'
            }
        },
        {
            name: 'Commandes',
            url: '/commerce/commandes',
            icon: 'cui-basket-loaded',
            meta: {
                caps: [
                    'order_management_get'
                ]
            }
        },
        {
            name: 'Limités',
            url: '/commerce/abonnements-limites',
            icon: 'fa fa-sort-numeric-desc',
            meta: {
                caps: [
                    'subscription_management_get'
                ]
            }
        },
        {
            name: 'Récurrents',
            url: '/commerce/abonnements-recurrents',
            icon: 'fa fa-refresh',
            meta: {
                caps: [
                    'subscription_management_get'
                ]
            }
        },
        {
            name: 'Produits',
            url: '/commerce/produits',
            icon: 'fa fa-tag',
            meta: {
                caps: [
                    'product_management_get'
                ]
            }
        },
        {
            name: 'Codes promos',
            url: '/commerce/codes-promotionnels',
            icon: 'fa fa-certificate',
            meta: {
                caps: [
                    'promo_code_management_get'
                ]
            }
        },
        {
            title: true,
            name: 'Classeur BETA',
            class: '',
            meta: {
                caps: [
                    'binder_management_get',
                    'binder_management_post',
                    'binder_management_put'
                ],
                binder: true
            }
        },
        {
            name: 'Classeurs',
            url: '/classeur/classeurs',
            icon: 'fa fa-archive',
            class: '',
            meta: {
                caps: [
                    'binder_management_get',
                    'binder_management_post',
                    'binder_management_put'
                ]
            }
        },
        {
            title: true,
            name: 'Formulaire',
            class: '',
            meta: {
                caps: [
                    'form_management_get'
                ]
            }
        },
        {
            name: 'Entrées',
            url: '/formulaire/entrees',
            icon: 'cui-pencil',
            meta: {
                caps: [
                    'form_management_get'
                ]
            }
        },
        {
            name: 'Gabarits',
            url: '/formulaire/gabarits',
            icon: 'fa fa-image',
            meta: {
                caps: [
                    'form_management_get'
                ]
            }
        },
        {
            title: true,
            name: 'Billetterie',
            class: '',
            meta: {
                caps: [
                    'ticketing_template_management_get'
                ],
                settings: [
                    'commerce.product.ticketIsEnabled'
                ]
            }
        },
        {
            name: 'Gabarits',
            url: '/billetterie/gabarits',
            icon: 'fa fa-image',
            meta: {
                caps: [
                    'ticketing_template_management_get'
                ],
                settings: [
                    'commerce.product.ticketIsEnabled'
                ]
            }
        },
        {
            title: true,
            name: 'Participant',
            class: '',
            meta: {
                caps: [
                    'participant_team_management_get',
                    'participant_category_management_get',
                    'league_management_get'
                ],
                settings: [
                    'commerce.product.participantCategoryIsEnabled',
                    'commerce.product.teamIsEnabled',
                    'event.leagueIsEnabled'
                ]
            }
        },
        {
            name: 'Ligues',
            url: '/participant/ligues',
            icon: 'fa fa-sitemap',
            meta: {
                caps: [
                    'league_management_get'
                ],
                settings: [
                    'event.leagueIsEnabled'
                ]
            }
        },
        {
            name: 'Équipes',
            url: '/participant/equipes',
            icon: 'cui-people',
            meta: {
                caps: [
                    'participant_team_management_get'
                ],
                settings: [
                    'commerce.product.teamIsEnabled'
                ]
            }
        },
        {
            name: 'Catégories',
            url: '/participant/categories',
            icon: 'cui-tags',
            meta: {
                caps: [
                    'participant_category_management_get'
                ],
                settings: [
                    'commerce.product.participantCategoryIsEnabled'
                ]
            }
        },
        {
            title: true,
            name: 'Lieu',
            class: '',
            meta: {
                caps: [
                    'place_address_management_get',
                    'place_district_management_get',
                ],
                settings: [
                    'event.placeIsEnabled'
                ]
            }
        },
        {
            name: 'Adresses',
            url: '/lieu/adresses',
            icon: 'fa fa-map-marker',
            meta: {
                caps: [
                    'place_address_management_get'
                ],
                settings: [
                    'event.placeIsEnabled'
                ]
            }
        },
        {
            name: 'Villes',
            url: '/lieu/villes',
            icon: 'fa fa-map',
            meta: {
                caps: [
                    'place_city_management_get'
                ],
                settings: [
                    'event.placeIsEnabled'
                ]
            }
        },
        {
            name: 'Régions',
            url: '/lieu/regions',
            icon: 'cui-map',
            meta: {
                caps: [
                    'place_district_management_get'
                ],
                settings: [
                    'event.placeIsEnabled'
                ]
            }
        },
        {
            title: true,
            name: 'Médiathèque',
            class: '',
            meta: {
                caps: [
                    'hidden'
                ]
            }
        },
        {
            name: 'Vidéos',
            url: '/theme/colors',
            icon: 'fa fa-play',
            meta: {
                caps: [
                    'hidden'
                ]
            }
        },
        {
            name: 'Documents',
            url: '/theme/colors',
            icon: 'fa fa-files-o',
            meta: {
                caps: [
                    'hidden'
                ]
            }
        },
        {
            title: true,
            name: 'Outils',
            class: '',
            meta: {
                caps: [
                    'report_commerce',
                    'report_event',
                    'report_system'
                ]
            }
        },
        {
            name: 'Rapports',
            url: '/outils/rapports',
            icon: 'cui-graph',
            meta: {
                caps: [
                    'report_commerce',
                    'report_event',
                    'report_system'
                ]
            }
        },
        {
            title: true,
            name: 'Système',
            class: '',
            meta: {
                caps: [
                    'role_management_get',
                    'user_management_get',
                ]
            }
        },
        {
            name: 'Utilisateurs',
            url: '/systeme/utilisateurs',
            icon: 'cui-people',
            meta: {
                caps: [
                    'user_management_get'
                ]
            }
        },
        {
            name: 'Rôles',
            url: '/systeme/roles',
            icon: 'cui-lock-locked',
            meta: {
                caps: [
                    'role_management_get'
                ]
            }
        },
        {
            name: 'Établissements',
            url: '/systeme/etablissements',
            icon: 'cui-home',
            meta: {
                caps: [
                    'branch_management_get'
                ]
            }
        },
        {
            name: 'Paramètres',
            url: '/systeme/parametres',
            icon: 'cui-settings',
            meta: {
                caps: [
                    'setting_management_get'
                ]
            }
        },
        {
            title: true,
            name: 'Compte',
            class: '',
            meta: {
                caps: [
                    'profile'
                ]
            }
        },
        {
            name: 'Mon profil',
            url: '/compte/profil',
            icon: 'fa fa-user',
            meta: {
                caps: [
                    'profile'
                ]
            }
        },
        {
            name: 'Support',
            url: '/systeme/support',
            icon: 'fa fa-support',
            meta: {
                caps: [
                    'setting_management_get'
                ]
            }
        },
        {
            title: true,
            name: 'Plateforme',
            class: '',
            meta: {
                caps: [
                    'platform_management'
                ]
            }
        },
        {
            name: 'Environnements',
            url: '/plateforme/environnements',
            icon: 'cui-layers',
            meta: {
                caps: [
                    'platform_management'
                ]
            }
        }
    ],
    displayConditions(item) {
        if (item.meta !== undefined) {
            if (item.meta.displayConditions!== undefined) {
                switch(item.meta.displayConditions)
                {
                    case 'hasOrders':
                        return Core.Session.AuthUser.hasOrders
                        break
                    case 'hasLimitedSubscriptions':
                        return Core.Session.AuthUser.hasLimitedSubscriptions
                        break
                    case 'hasRecurringSubscriptions':
                        return Core.Session.AuthUser.hasRecurringSubscriptions
                        break
                }
            }
        }
        return true;
    },
    getNav() {
        let items = []
        for (let item in this.items) {
            item = this.items[item]

            if (this.displayConditions(item)) {
                if (item.meta === undefined || item.meta.caps === undefined) {
                    items.push(item)
                } else {
                    let navItemCaps = item.meta.caps
                    
                    if (Core.Session.AuthUser.can(navItemCaps)) {
                        if (undefined !== item.meta.settings) {
                            let settings = item.meta.settings
                            for (let setting in settings) {
                                setting = settings[setting]
                                if (Core.Value.encode(Core.Session.Setting.getSetting(setting), 'checkbox') === true) {
                                    items.push(item)
                                    break
                                }
                            }
                        } else {
                            items.push(item)
                        }
                    }
                }
            }

            if (item.meta.binder !== undefined && item.meta.binder === true) {
                for (let binder in Session.binders) {
                    binder = Session.binders[binder]
                    items.push({
                        name: binder.plurialTitle,
                        url: binder.url,
                        binder: true,
                        meta: {
                            caps: []
                        },
                        icon: binder.icon
                    })
                }
            }
        }
        return items
    }
}
